import React from "react";
import {MainLayout} from "../../main-layout";
import {article} from "../../advice/styles";

export const ServiceServisnyyCentr = () => {
    return (
        <MainLayout>
            <div className={article}>
                <div className="container service-page">
                    <section>
                    <div className="row">
                        <div className="header">
                            <h1>
                                Сервисный центр в Лемана ПРО Москва
                            </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="service-content">
                            <div className="service-section section">
                                <div className="service-section-comp" id="service_section"
                                     data-navtitle="Общая информация">
                                    <div className="par service-section-parsys parsys">
                                        <div className="adaptiveImage parbase section">
                                            <img
                                                src="https://cdn.lemanapro.ru/lmru/image/upload/v1530723437/fudzi/elbrus/images/servicebigicon/desctop/serv-centre.svg/serv-centre.svg"
                                                data-desktopref="https://cdn.lemanapro.ru/lmru/image/upload/v1530723437/fudzi/elbrus/images/servicebigicon/desctop/serv-centre.svg/serv-centre.svg"
                                                data-tabletref="https://cdn.lemanapro.ru/lmru/image/upload/v1530607841/fudzi/elbrus/images/servicebigicon/tablet/service centr tab.svg/service centr tab.svg"
                                                data-mobileref="https://cdn.lemanapro.ru/lmru/image/upload/v1530723438/fudzi/elbrus/images/servicebigicon/mobile/service centr mob.svg/service centr mob.svg"
                                                className="resize-image"/>
                                        </div>
                                        <div className="store-selector section">
                                            <div className="store-selector-all-stores">
                                                <span className="lm icon-circle-info store-selector-info"></span>
                                                <span className="store-selector-text">Условия предоставления услуги одинаковы во всех магазинах текущего региона</span>
                                            </div>
                                        </div>
                                        <div className="text parbase section"><p><span className="rte-standard">В каждом магазине Лемана ПРО есть Сервисный центр или Информационное бюро. Там наши сотрудники ответят на все ваши вопросы и помогут решить проблемы с купленным товаром. Вопросы и проблемы с товарами ненадлежащего качества рассматриваются в рамках Закона о защите прав потребителей.</span>
                                        </p>
                                            <p><span className="rte-standard">Если проблема возникла с товаром собственной торговой марки Лемана ПРО, мы организуем сервисное обслуживание и решим вопрос не больше, чем за 14 календарных дней. Выбирая товары наших брендов, вы получаете быстрый и удобный сервис как дополнительное преимущество.&nbsp;
                                                <br/>
&nbsp;</span></p>
                                            <p><span className="rte-standard">Что можно сделать в нашем Сервисном центре:</span>
                                            </p>
                                            <ul>
                                                <li><span className="rte-standard">передать товар на проверку качества или ремонт в авторизованном сервисном центре производителя в течение гарантийного срока;</span>
                                                </li>
                                                <li><span className="rte-standard">получить информацию о сроках выполнения проверки качества или ремонта товара;</span>
                                                </li>
                                                <li><span className="rte-standard">узнать, как продвигается проверка качества или ремонта вашего товара;</span>
                                                </li>
                                                <li><span className="rte-standard">получить информацию о ближайших авторизированных сервисных центрах производителей.</span>
                                                </li>
                                            </ul>
                                            <p>&nbsp;</p>
                                            <p><b><span className="rte-standard">ВНИМАНИЕ! Все услуги Сервисного центра Лемана ПРО бесплатны в течение гарантийного срока товара.</span></b>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                </div>
            </div>
        </MainLayout>
    )
}